// extracted by mini-css-extract-plugin
export default {"toggleFacetInput":"ToggleFacet_toggleFacetInput__pV3p9","toggleFacetLabel":"ToggleFacet_toggleFacetLabel__6oTYU"};